import { FC, useCallback } from 'react';
import PopUpContentWrapper from 'src/components/PopUpContentWrapper';
import Button, { isButtonDisabled } from 'src/components/design-system/Button';
import PopUp from 'src/components/design-system/PopUp';
import useUnDeleteInvoicesApi from 'src/services/useUnDeleteInvoicesApi';
import { useContextSelector } from 'use-context-selector';
import { InvoiceContext } from './InvoiceDetailsContext';
import useInvoiceButtonState from './useInvoiceButtonState';

interface UnDeleteInvoiceProps {}

const UnDeleteInvoice: FC<UnDeleteInvoiceProps> = () => {
  const invoiceId = useContextSelector(InvoiceContext, (value) => value.invoiceId);
  const refreshPage = useContextSelector(InvoiceContext, (value) => value.refreshPage);

  const { unDeleteInvoices, unDeleteInvoiceLoading } = useUnDeleteInvoicesApi();
  const [message, buttonState] = useInvoiceButtonState('Undelete');

  const handleUnDeleteInvoice = useCallback(async () => {
    const invoiceIds: string[] = [invoiceId];
    try {
      await unDeleteInvoices({ invoiceIds });
    } catch (e) {
      console.error(e);
    } finally {
      refreshPage();
    }
  }, [invoiceId, refreshPage, unDeleteInvoices]);

  return (
    <PopUp
      popupAlign={{ horizontal: 'center', vertical: 'top' }}
      content={
        <div className="m-1 max-w-[350px]">
          <PopUpContentWrapper type="Error" contents={[...message]} />
        </div>
      }
      show={isButtonDisabled(buttonState)}
    >
      <Button
        onClick={handleUnDeleteInvoice}
        color="dark"
        buttonState={buttonState}
        disabled={isButtonDisabled(buttonState)}
        loading={unDeleteInvoiceLoading}
      >
        Undelete
      </Button>
    </PopUp>
  );
};

export default UnDeleteInvoice;
